import { render, staticRenderFns } from "./CryptomatsFees.vue?vue&type=template&id=57e00c28&scoped=true&"
import script from "./CryptomatsFees.vue?vue&type=script&lang=js&"
export * from "./CryptomatsFees.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsFees.vue?vue&type=style&index=0&id=57e00c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e00c28",
  null
  
)

export default component.exports